export default {"src":"/_next/static/media/prioritas-bos-outline.17156900.gif","height":129,"width":710};